const i18n = require("LanguageData");

const {ccclass, property} = cc._decorator;

@ccclass
export default class NewClass extends cc.Component {
    start () {
    } 

    onBtnZhong () {
        i18n.init('zh')
    }

    onBtnYing () {
        i18n.init('en')
    }
}